import React from 'react';
import useI18n from '@/hooks/useI18n';
import { formatCount } from '@/utils/numberUtils';

interface CampaignStatsGridProps {
  totalViews: number;
  totalLikes: number;
  totalShares: number;
  totalPosts: number;
}

const CampaignStatsGrid: React.FC<CampaignStatsGridProps> = ({
  totalViews,
  totalLikes,
  totalShares,
  totalPosts,
}) => {
  const { t } = useI18n();

  const cells = [
    { id: 'views', label: t('common.totalViews'), value: totalViews },
    { id: 'likes', label: t('common.totalLikes'), value: totalLikes },
    { id: 'shares', label: t('common.totalShares'), value: totalShares },
    { id: 'posts', label: t('common.totalPosts'), value: totalPosts },
  ];

  return (
    <div
      data-testid="campaign-stats-grid"
      className="w-full overflow-hidden rounded-3xl border border-[#E9E9E9] bg-white"
    >
      <div className="flex w-full flex-wrap md:flex-nowrap">
        {cells.map((cell, index) => (
          <div
            key={cell.label}
            data-testid={`stat-${cell.id}`}
            className={`flex min-w-0 flex-[1_0_50%] flex-col items-start gap-1 p-4 md:flex-1 ${
              index < cells.length - 1 ? 'md:border-r md:border-[#E9E9E9]' : ''
            }`}
          >
            <p
              data-testid="stat-value"
              className="font-header text-2xl font-normal leading-8 text-[#191B1C]"
            >
              {formatCount(cell.value)}
            </p>
            <p className="font-header text-xs font-normal leading-4 text-[#9B919D]">
              {cell.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignStatsGrid;
